import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Noticia } from '../../../../models/noticias/noticia';
import { NoticiasService } from '../../../../services/noticias/noticias.service';

export class NoticiasDatabase {
    /** Stream that emits whenever the data has been modified. */
    dataChange: BehaviorSubject<Noticia[]> = new BehaviorSubject<Noticia[]>([]);

    get data(): Noticia[] {
        return this.dataChange.value;
    }

    constructor(
        private subjectService: NoticiasService,
        private tipoNoticias: any[],
    ) {
        setTimeout(() => {
            this.subjectService.getAll().subscribe(response => {
                console.log('response>>>>>>', response);
                for (const r of response) {
                    this.add(r);
                }
            }, error => {

            });
        }, 100);
    }

    buscarIdEnArray(menus, idBuscado) {
        console.log(menus, idBuscado);
        for (const menu of menus) {
            if (menu.Id === idBuscado) {
                return menu.Nombre
            }
    
            // Buscar en los hijos
            if (menu.Hijos) {
                for (const hijo of menu.Hijos) {
                    if (hijo.Id === idBuscado) {
                        return menu.Nombre + " > " + hijo.Nombre
                    }
                }
            }
        }
        
        return ""
    }

    public add(store: Noticia) {
        store.MenuPathFull =  this.buscarIdEnArray(this.tipoNoticias, store.TipoNoticiaId)
        const copiedData = this.data.slice();
        copiedData.push(store);
        this.dataChange.next(copiedData);
    }

    public edit(store: Noticia) {
        console.log(store);
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData[index] = store;
        this.dataChange.next(copiedData);
    }

    public delete(store: Noticia) {
        const copiedData = this.data.slice();
        const index = copiedData.findIndex(st => st.Id === store.Id);
        copiedData.splice(index, 1);
        this.dataChange.next(copiedData);
    }

    public refresh() {
        this.dataChange.next([]);
        console.log('this.dataChange >>>>>>>>>>>>>>>>>>>> ');
        this.subjectService.getAll().subscribe(response => {
            for (const r of response) {
                this.add(r);
            }
        }, error => {

        });
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/noticiasDatabase.ts